// extracted by mini-css-extract-plugin
export default {"host":"ContextMenu_host__tY0kH"};